import { Button, useTheme } from "@mui/material";
import { IButtons } from "./Types/Buttons.types";

export const ButtonIconOnly = ({
  onClick,
  disabled,
  iconOnly,
  sxButton,
  id,
}: IButtons) => {
  const theme = useTheme();
  return (
    <Button
      id={id}
      onClick={onClick}
      disabled={disabled}
      sx={{
        backgroundColor: !disabled
          ? theme.palette.backgroundPrimary
          : theme.palette.backgroundDisabledAlternative,
        color: theme.palette.text.primary,
        opacity: disabled ? 0.3 : 1,
        height: "2rem",
        width: "2rem",
        lineHeight: "1.5rem",
        borderRadius: "8px",
        fontWeight: 600,
        fontSize: "0.75rem",
        fontStyle: "normal",
        border: `2px solid ${theme.palette.text.primary}`,
        padding: 0,
        minWidth: "unset",
        "&:hover": {
          backgroundColor: theme.palette.backgroundSecondaryCTAHover,
        },
        ...sxButton,
        //TODO da finire i vari stati (active, focus)
      }}
    >
      {iconOnly}
    </Button>
  );
};
